export const panelStyle = {
  width: "100%",
  flexGrow: "1",
  border: "1px solid #ccc",
  backgroundColor: (theme) => theme.palette.background.paper,
  borderRadius: 1,
  marginLeft: 0,
};
